import { queryOptions } from '@tanstack/react-query';
import { archivePageSchema, type ArchivePage, type ArchiveType } from '@molt/shared';
import { get } from './api';
import { queryKeys } from './query-keys';

export interface BoardArchiveQueryInput {
  readonly boardId: string;
  readonly type: ArchiveType;
  readonly q?: string | undefined;
  readonly cursor?: string | undefined;
  readonly limit?: number | undefined;
}

function archiveSearchParams(input: BoardArchiveQueryInput): URLSearchParams {
  const params = new URLSearchParams();
  params.set('type', input.type);
  const q = input.q?.trim();
  if (q !== undefined && q.length > 0) params.set('q', q);
  if (input.cursor !== undefined) params.set('cursor', input.cursor);
  if (input.limit !== undefined) params.set('limit', String(input.limit));
  return params;
}

export function getBoardArchive(input: BoardArchiveQueryInput): Promise<ArchivePage> {
  const params = archiveSearchParams(input);
  return get(
    `/boards/${encodeURIComponent(input.boardId)}/archive?${params.toString()}`,
    archivePageSchema,
  );
}

export function boardArchiveQueryOptions(
  input: BoardArchiveQueryInput & { readonly enabled?: boolean | undefined },
) {
  return queryOptions({
    queryKey: queryKeys.boards.archive(
      input.boardId,
      input.type,
      input.q?.trim(),
      input.cursor,
      input.limit,
    ),
    queryFn: () => getBoardArchive(input),
    enabled: input.enabled ?? true,
  });
}
